import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-invoice-create-credit-note-warnings-dialog',
  templateUrl: './invoice-create-credit-note-warnings-dialog.component.html',
  styleUrls: ['./invoice-create-credit-note-warnings-dialog.component.scss']
})
export class InvoiceCreateCreditNoteWarningsDialogComponent implements OnInit {
  accepted: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      warnings: any[];
    },
  ) {
    console.log('data',data)
  }

  ngOnInit(): void {
  }

}
